<template>
<span>
  <v-dialog
    v-model='visible' fullscreen >
    <v-card>
      <v-toolbar dense flat >
        <v-toolbar-title>Physitrack</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn icon @click='visible=false' ><v-icon>close</v-icon></v-btn>
      </v-toolbar>
      <v-card-text v-if='requests.get.loading' >
        <center>
          <v-progress-circular class='ma-4 pa-4' indeterminate color='amber' width='3' size='36' >
          </v-progress-circular>
          <br/>
          Loading
        </center>
      </v-card-text>
      <template v-else >
        <template v-if='!physitrackClientId' >
          <v-alert
            :value='true' type='info' outline outlined class='ma-3' >
            <strong>{{relationshipFirstName}} {{relationshipLastName}}
              <span v-if='dob' v-text='dob' ></span>
            </strong><br/>
            User does not exist in Physitrack. Would you like to create a user?
            <request-status :request='requests.create' >
            </request-status>
            <v-form v-model='isValid' >
            <v-layout class='mt-2'>
              <v-flex>
                <v-text-field
                  @keypress.enter.stop='create'
                  :rules="[rules.required, rules.validDate]"
                  v-model='date_of_birth'
                  hint='Date of birth is required by Physitrack and the user will use the _year_ to log in to physitrack'
                  :persistent-hint='true'
                  :error-messages='createClientErrors.date_of_birth'
                  placeholder='yyyy-mm-dd'
                  label='Date of birth (yyyy-mm-dd)' >
                </v-text-field>
                <small>
                  <strong>TIP:</strong>
                  if you do not know the date of birth, you can make something up. But try get the year right if you can
                </small>
              </v-flex>
              <v-flex>
                <v-btn
                  :disabled='!isValid'
                  :loading='requests.create.loading'
                  @click='create' color='primary' >Create</v-btn>
              </v-flex>
            </v-layout>
            </v-form>

          </v-alert >
          <v-layout >
            <v-subheader class='overline' >Or, link to an existing client in Physitrack</v-subheader>
          </v-layout>
          <v-layout>
            <v-flex >
              <v-text-field persistent-hint
                @click:append='getClients(lastName)'
                @keypress='debounceSearch'
                v-model='lastName'
                :loading='requests.clients.loading'
                label='Look for a client in Physitrack'
                hint='Search the last name of a client in Physitrack (note: search is case sensitive and must be an exact match)'
                class='ma-3'
                append-icon='search' >
              </v-text-field>
            </v-flex>
            <v-flex >
              <v-btn small class='mt-4'
                @click='getClients(lastName)'
                :loading='requests.clients.loading' >Search</v-btn>
            </v-flex>
          </v-layout>
          <!-- S: {{requests.clients.status}} -->
          <template v-if='requests.clients.status === 200' >
            <v-list v-if='clients && clients.length > 0' subheader>
              <v-subheader class='overline' >
                Matches found
              </v-subheader>
              <v-layout row wrap>
                <v-flex xs6 >
                  <physitrack-client-list-item
                    v-for='(client, index) in clients'
                    v-model='clients[index]'
                    :key='client.id' >
                    <v-list-tile-action slot='action' >
                      <v-btn @click='link(client.id)' :loading='requests.link.loading' color='primary' small >Link</v-btn>
                    </v-list-tile-action>
                  </physitrack-client-list-item>
                </v-flex>
              </v-layout>
            </v-list>
            <v-alert
              v-else :value='true' outline class='pa-0 mx-3' type='info'>
              No clients found with surname <strong>{{lastName}}</strong>
            </v-alert>
          </template>
        </template>

        <!-- Rel: {{relationshipId}} / {{physitrackClientId}}
        <v-btn @click='get' >Get</v-btn> -->

        <!-- <pre>{{physitrackClient}}</pre> -->
        <programs
          v-if='physitrackClientId && relationshipId'
          :physitrack-client-id='physitrackClientId'
          :relationship-id=relationshipId
          :touch='physiTouch'
          v-model='physitrackClient' >
        </programs>
      </template>
    </v-card>
  </v-dialog>
  <v-chip @click='visible=true' small >
    <v-avatar left ><v-icon small >expand_more</v-icon></v-avatar>
    Physitrack
  </v-chip>
</span>
</template>
<script>
// const TEST_CLIENT = false // 7441236
import PhysitrackClientListItem from './PhysitrackClientListItem.vue'
import Programs from './Programs.vue'
import RequestStatus from '@/components/ui/RequestStatus.vue'
import moment from 'moment'
import Vue from 'vue'

export default {
  name: 'PhysitrackEmbed',
  components: {Programs, PhysitrackClientListItem, RequestStatus},
  props: {
    relationshipId: { required: true }
  },
  data () {
    return {
      isValid: false,
      search: '',
      visible: false,
      physiTouch: 0,
      lastName: '',
      date_of_birth: '',
      searchTimeout: false,
      rules: {
        required: value => !!value || 'Please provide a date of birth',
        validDate: value => {
          let res = moment(value, 'YYYY-MM-DD', true).isValid()
          if (!res) { return 'Enter a date in the format YYYY-MM-DD' }
          return res
        }
      },
      requests: {
        get: {
          resource: 'ag.integrations',
          extra: 'physitrack/client',
          result: {}
        },
        clients: {
          resource: 'ag.integrations',
          extra: 'physitrack/clients',
          result: {}
        },
        create: {
          resource: 'ag.integrations',
          extra: 'physitrack/client'
        },
        link: {
          resource: 'ag.integrations',
          extra: 'physitrack/link'
        }
      },
      physitrackClient: {}
    }
  },
  watch: {
    // relationshipId () {
    //   if (this.relationshipId) {

    //     // this.get()
    //   }
    // },
    dob () {
      this.date_of_birth = this.dob
    },
    visible () {
      if (this.visible) {
        this.requests.get.result = {}
        this.physitrackClient = {}
        this.get()
      }
    },
    getStatus () {
      if (this.getStatus === 200) {
        if (this.clientlist.length > 0) {
          this.physitrackClient = this.clientlist[0]
        }
      }
      let isNewClient = (this.getStatus === 404)
      if (isNewClient) {
        this.getClients(this.lastName)
      }
    },
    createStatus () {
      if (this.getStatus >= 200) {
        if (this.newclient && this.newclient.id) {
          this.physitrackClient = this.newclient
        }
      }
    },
    linkStatus () {
      if (this.linkStatus >= 200) {
        if (this.linkedclient && this.linkedclient.id) {
          this.physitrackClient = this.linkedclient
        }
      }
    },
    relationshipLastName: {
      immediate: true,
      handler () {
        this.lastName = this.relationshipLastName
      }
    }
  },
  computed: {
    getStatus () {
      return this.requests.get.status
    },
    createStatus () {
      return this.requests.create.status
    },
    linkStatus () {
      return this.requests.link.status
    },
    clientlist () {
      return this.getObjectPath(this.requests, 'get.result.clients', [])
    },
    newclient () {
      return this.getObjectPath(this.requests, 'create.result', {})
    },
    linkedclient () {
      return this.getObjectPath(this.requests, 'link.result', {})
    },
    physitrackClientId () {
      if (this.physitrackClient && this.physitrackClient.id) {
        return this.physitrackClient.id
      }
      return null
    },
    relationship () {
      let req = this.$store.getters.getRequestById('get-relationship-request', true)
      return this.getObjectPath(req, 'result.data', {})
    },
    relationshipFirstName () {
      return this.getObjectPath(this.relationship, 'client.first_name', false)
    },
    relationshipLastName () {
      return this.getObjectPath(this.relationship, 'client.last_name', false)
    },
    dob () {
      // return this.relationship
      return this.getObjectPath(this.relationship, 'record.patient.date_of_birth', false)
    },
    clients () {
      return this.getObjectPath(this.requests, 'clients.result.clients', [])
    },
    createClientErrors () {
      return this.getObjectPath(this.requests.create, 'error', {})
    }
  },
  methods: {
    get () {
      this.requests.get.params = {relationship_id: this.relationshipId}
      this.$request('get', this.requests.get)
    },
    getClients (lastName) {
      if (!lastName) {
        lastName = this.lastName
      }
      this.requests.clients.params = {last_name: lastName}
      this.$request('get', this.requests.clients)
    },
    create () {
      this.requests.create.data = {
        relationship: this.relationshipId,
        date_of_birth: this.date_of_birth
      }
      this.$request('save', this.requests.create)
    },
    debounceSearch () {
      Vue.set(this.requests.clients, 'status', 0)
      if (this.searchTimeout) {
        window.clearTimeout(this.searchTimeout)
      }
      this.searchTimeout = window.setTimeout(this.getClients, 1000)
    },
    link (physitrackId) {
      this.requests.link.data = {
        relationship_id: this.relationshipId,
        physitrack_id: physitrackId
      }
      this.$request('save', this.requests.link)
    }
  }
}
</script>



// WEBPACK FOOTER //
// PhysitrackEmbed.vue?adba3bbe